import { render, staticRenderFns } from "./centerB-Left-temp3.vue?vue&type=template&id=13f7e268&scoped=true"
import script from "./centerB-Left-temp3.vue?vue&type=script&lang=js"
export * from "./centerB-Left-temp3.vue?vue&type=script&lang=js"
import style0 from "./centerB-Left-temp3.vue?vue&type=style&index=0&id=13f7e268&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f7e268",
  null
  
)

export default component.exports